// Centralized API base URL for the nested app
// Default to production API, allow override via REACT_APP_API_BASE_URL environment variable
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.stocks4u.in';


